import { render } from "./FolderForm.vue?vue&type=template&id=9d250a94"
import script from "./FolderForm.vue?vue&type=script&lang=js"
export * from "./FolderForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__